module.exports = __webpack_public_path__ + "img/e52e3665eaf016cebe5a7153fb303681.png";